"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _require = require("../utils/errors"),
  DataError = _require.DataError;
var BaseDataObject = /*#__PURE__*/function () {
  function BaseDataObject(data) {
    var shouldImmediatelyBuild = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    (0, _classCallCheck2["default"])(this, BaseDataObject);
    (0, _defineProperty2["default"])(this, "valueObject", {});
    (0, _defineProperty2["default"])(this, "requiredFields", []);
    (0, _defineProperty2["default"])(this, "optionalFields", []);
    (0, _defineProperty2["default"])(this, "throwErrorOnUnused", false);
    (0, _defineProperty2["default"])(this, "acceptNulls", false);
    (0, _defineProperty2["default"])(this, "objectFieldsToFilter", []);
    (0, _defineProperty2["default"])(this, "allowAllFields", false);
    (0, _defineProperty2["default"])(this, "_rawData", null);
    this._rawData = data;
    if (data && shouldImmediatelyBuild) {
      this.buildObjectWithData(data);
    }
  }
  return (0, _createClass2["default"])(BaseDataObject, [{
    key: "toPresentationalObject",
    value:
    /**
     * This is how the cleaned object is returned to the outside world, override this when extending the class if you want to add extra formatting
     * @param {*} obj
     * @returns *
     */
    function toPresentationalObject(obj) {
      return obj;
    }
  }, {
    key: "present",
    value: function present() {
      var value = this._purgeKeysAndBuildJSON();
      return this.toPresentationalObject(value);
    }
  }, {
    key: "buildObjectWithData",
    value: function buildObjectWithData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._rawData;
      this.valueObject = {};
      var _iterator = _createForOfIteratorHelper(BaseDataObject.filterBaseKeys(data)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          this.valueObject[key] = data[key];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return this;
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this$_getUnprocessab = this._getUnprocessableKeys(),
        _this$_getUnprocessab2 = (0, _slicedToArray2["default"])(_this$_getUnprocessab, 2),
        missingRequiredFields = _this$_getUnprocessab2[0],
        unspecifiedKeys = _this$_getUnprocessab2[1];
      if (missingRequiredFields.length !== 0) {
        throw new DataError("Data object payload malformed, required keys missing: ".concat(JSON.stringify(missingRequiredFields)));
      }
      if (this.throwErrorOnUnused && unspecifiedKeys.length > 0) {
        throw new DataError("Data object payload has unexpected data: ".concat(JSON.stringify(unspecifiedKeys)));
      }
      return this;
    }
  }, {
    key: "_purgeUnusedFields",
    value: function _purgeUnusedFields() {
      var _this$_getUnprocessab3 = this._getUnprocessableKeys(),
        _this$_getUnprocessab4 = (0, _slicedToArray2["default"])(_this$_getUnprocessab3, 2),
        unspecifiedKeys = _this$_getUnprocessab4[1];
      var _iterator2 = _createForOfIteratorHelper(unspecifiedKeys),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          delete this.valueObject[key];
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return this;
    }
  }, {
    key: "_toJSON",
    value: function _toJSON() {
      var _this = this;
      return BaseDataObject.filterBaseKeys(this.valueObject).reduce(function (obj, key) {
        return _objectSpread(_objectSpread({}, obj), {}, (0, _defineProperty2["default"])({}, key, _this.valueObject[key]));
      }, {});
    }
  }, {
    key: "_filterDataObjectKeys",
    value: function _filterDataObjectKeys() {
      var _this2 = this;
      return BaseDataObject.filterBaseKeys(this.valueObject).filter(function (key) {
        return !_this2.objectFieldsToFilter.includes(key);
      }).filter(function (k) {
        return Object.prototype.hasOwnProperty.call(_this2.valueObject, k);
      });
    }
  }, {
    key: "_isFalsyValueInvalid",
    value: function _isFalsyValueInvalid(value) {
      return value === undefined || !this.acceptNulls && value === null;
    }
  }, {
    key: "_getUnprocessableKeys",
    value: function _getUnprocessableKeys() {
      var _this3 = this;
      var missingRequiredFields = (0, _toConsumableArray2["default"])(this.requiredFields);
      var allFields = [].concat((0, _toConsumableArray2["default"])(this.requiredFields), (0, _toConsumableArray2["default"])(this.optionalFields));
      var unspecifiedKeys = [];
      var _iterator3 = _createForOfIteratorHelper(this._filterDataObjectKeys()),
        _step3;
      try {
        var _loop = function _loop() {
          var key = _step3.value;
          missingRequiredFields = _this3._isFalsyValueInvalid(_this3.valueObject[key]) ? missingRequiredFields : missingRequiredFields.filter(function (k) {
            return k !== key;
          });
          if (!allFields.find(function (k) {
            return k === key;
          })) {
            unspecifiedKeys.push(key);
          } else {
            allFields = allFields.filter(function (k) {
              return k !== key;
            });
          }
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return [missingRequiredFields, this.allowAllFields ? [] : unspecifiedKeys];
    }
  }, {
    key: "_purgeKeysAndBuildJSON",
    value: function _purgeKeysAndBuildJSON() {
      return this._purgeUnusedFields().validate()._toJSON();
    }
  }], [{
    key: "filterBaseKeys",
    value: function filterBaseKeys(data) {
      return Object.keys(data).filter(function (key) {
        return !BaseDataObject._baseFilters.includes(key);
      });
    }
  }]);
}();
(0, _defineProperty2["default"])(BaseDataObject, "_baseFilters", ["requiredFields", "throwErrorOnUnused", "optionalFields", "acceptNulls", "_baseFilters", "objectFieldsToFilter"]);
module.exports = BaseDataObject;